import { render, staticRenderFns } from "./GlLevel1CheckersQueue.vue?vue&type=template&id=709e3cd6&"
import script from "./GlLevel1CheckersQueue.vue?vue&type=script&lang=js&"
export * from "./GlLevel1CheckersQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports